import React from "react";
import { Skeleton, Stack } from "@mui/material";

export default function PacksLoader(props) {
	const [tiers, setTiers] = React.useState(2);
	const [buttonsAmount, setButtonsAmount] = React.useState(1);

	React.useEffect(() => {
		if (props.tiers) {
			setTiers(props.tiers);
		}

		if (props.buttonsAmount) {
			setButtonsAmount(props.buttonsAmount);
		}
		return () => {
			setTiers(2);
			setButtonsAmount(1);
		};
	}, [props]);

	return (
		<React.Fragment>
			<Stack direction={"row"} spacing={2} mt={2} sx={props.sx || { padding: "0 32px" }}>
				<Stack spacing={1}>
					{Array.from(Array(tiers)).map((_, key) => (
						<Stack key={key} direction={"row"} spacing={2} mt={0.5}>
							<Stack direction={"column"} justifyContent={"center"} alignItems={"start"} spacing={1}>
								{!key && <Skeleton variant="text" width={90} height={20} />}
								<Skeleton variant="rectangular" width={180} height={30} sx={{ borderRadius: "6px" }} />
							</Stack>
							<Stack direction={"column"} justifyContent={"center"} alignItems={"center"} spacing={1}>
								{!key && <Skeleton variant="text" width={80} height={20} />}
								<Skeleton variant="rectangular" width={100} height={30} sx={{ borderRadius: "6px" }} />
							</Stack>
							<Stack direction={"column"} justifyContent={"center"} alignItems={"center"} spacing={1}>
								{!key && <Skeleton variant="text" width={0} height={20} />}
								<Stack direction={"row"} alignItems={"center"} spacing={1}>
									<Skeleton variant="rectangular" width={45} height={22} sx={{ borderRadius: "15px" }} />
									<Skeleton variant="text" width={60} height={20} />
								</Stack>
							</Stack>
							<Stack
								direction={"column"}
								justifyContent={"center"}
								alignItems={"center"}
								spacing={1}
								sx={{ marginLeft: "25px !important" }}
							>
								{!key && <Skeleton variant="text" width={0} height={20} />}
								<Skeleton variant="circular" width={32} height={32} />
							</Stack>
						</Stack>
					))}

					{props.buttons && (
						<Stack direction={"row"} justifyContent={"center"} spacing={1} mt={"16px !important"} width={490}>
							{Array.from(Array(buttonsAmount)).map((_, key) => (
								<Skeleton key={key} variant="rectangular" width={120} height={28} sx={{ borderRadius: "6px" }} />
							))}
						</Stack>
					)}
				</Stack>
				{props.selector && <Skeleton variant="rectangular" width={130} height={80} sx={{ borderRadius: "10px" }} />}
			</Stack>
		</React.Fragment>
	);
}
